import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon } = colorsPalettes;

export const ButtonGroup = styled(FlexRow)`
    box-sizing: border-box;
    gap: 4px;
    justify-content: end;
    width: 100%;
    padding: 8px 16px 16px 16px;
`;

export const Header = styled(FlexRow)`
    box-sizing: border-box;
    align-items: center;
    gap: 8px;
    padding: 20px 24px;
`;

export const Title = styled.div`
    ${setFontVariant("h5_2", carbon[500])};
`;

export const Text = styled.div`
    padding: 16px 24px 24px;
    ${setFontVariant("body1", carbon[400])};
`;
